export default () => {
    if (window.location.search && window.location.search.includes('utm_source')) {
        if (localStorage) {
            localStorage.setItem('utmUrl', window.location.href);
        }
    }
}